exports.init = ModalChangePermissions;

function ModalChangePermissions() {
  const $modal = $('#members-change-permissions');
  const btnPermission = $('.members-label-button');

  $('input[name=type]').on('change', function() {
    const isRequired = $(this).val() === 'USER';
    $('#enableCardUser').attr('required', isRequired);
    if (!isRequired) {
      $('#enableCardUser-error').css('display', 'none');
      $('#enableCardUser').closest('.form-group').removeClass('has-error');
    }
  });

  btnPermission.on('click', function() {
    const $form = $modal.find('form').first();

    const infoModalText = document.querySelector('.info-modal-text');
    const infoText = infoModalText.dataset.infoText;

    infoModalText.innerHTML = infoText.replace(':userName', $(this).data('name'));

    let inputName = document.querySelector('input[name=name]');
    let inputUserId = document.querySelector('input[name=uuid]');
    let inputMustHaveAccount = document.querySelector('input[name=mustHaveAccount]');
    let inputExistInCards = document.querySelector('input[name=existInCards]');

    if (!inputName) {
      inputName = document.createElement('input');
    }
    if (!inputUserId) {
      inputUserId = document.createElement('input');
    }
    if (!inputMustHaveAccount){
      inputMustHaveAccount = document.createElement('input');
    }
    if (!inputExistInCards){
      inputExistInCards = document.createElement('input');
    }

    let userType = $(this).data('user_type');

    if (!userType) {
      userType = 'USER';
    }

    if (userType === 'USER') {
      $('#enableCardUser').attr('required', 'true');
    }

    $(`#${userType.toLowerCase()}`).prop('checked', true);

    inputName.value = $(this).data('name');
    inputUserId.value = $(this).data('user_id');
    inputMustHaveAccount.value = $(this).data('must_have_account') || 0;
    inputExistInCards.value = $(this).data('exist_in_cards') || 0;

    inputName.type = 'hidden';
    inputUserId.type = 'hidden';
    inputMustHaveAccount.type = 'hidden';
    inputExistInCards.type = 'hidden';

    inputName.name = 'name';
    inputUserId.name = 'uuid';
    inputMustHaveAccount.name = 'mustHaveAccount';
    inputExistInCards.name = 'existInCards';

    if(inputMustHaveAccount.value == '1') {
      const inputEnableCardUser = $('#enableCardUser');
      inputEnableCardUser.attr('disabled', true);
      inputEnableCardUser.attr('checked', true);
      inputEnableCardUser.parent().addClass('active');
    }

    $form.append(inputName, inputUserId, inputMustHaveAccount,inputExistInCards);
  });
}
